import { render, staticRenderFns } from "./NextButton.vue?vue&type=template&id=3771b3e7&scoped=true&"
import script from "./NextButton.vue?vue&type=script&lang=js&"
export * from "./NextButton.vue?vue&type=script&lang=js&"
import style0 from "./NextButton.vue?vue&type=style&index=0&id=3771b3e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3771b3e7",
  null
  
)

export default component.exports